import type { ExploreContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './exploreContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type ExploreContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: ExploreContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
